export default "__VITE_ASSET__DymqpiuN__"